import {Icon} from "@iconify/react";
import {Button} from "react-bootstrap";
import React, { useState } from "react";



interface DataProps {
    subName: string;
    price?: number | undefined;
    obiPrice?: number | undefined;
    featuresIncluded: string[];
}

interface ComponentProps {
    data: DataProps, proceedForPayment: () => void
}


const SubscriptionCard = (props: ComponentProps) => {
    const { data, proceedForPayment } = props;
    return (
        <div className="PricingCardMain">
            <h6><i><lord-icon   src="https://cdn.lordicon.com/qucadebu.json" trigger="loop" colors="primary:#ffffff,secondary:#ffffff"></lord-icon> </i> Most Popular</h6>
            <h2>{data?.subName}</h2>
            {/* {data?.obiPrice && data?.obiPrice > 0 ? <h4>{data?.obiPrice.toFixed(2)} <small>Obi Tokens</small></h4> : <h4>${data?.price}</h4>} */}
            {data.price != 0 ? <h4 className="mb-0">${data?.price}</h4>: ""}
            <hr />
            {/* {data.price !== 0 && data?.obiPrice && data?.obiPrice > 0 ? <h6>{data?.obiPrice.toFixed(2)} Obi Tokens</h6> : ""} */}
            <ul className="Pricingplan-detail">
                {data.featuresIncluded.map((feat, index) => (
                    <li key={index}><i><Icon icon="ph:seal-check-fill"  /></i> <p>{feat}</p></li>
                ))}
            </ul>
            {data.price != 0 ?<Button variant="" type="button" className="btn btn-green" onClick={proceedForPayment}> Subscribe!</Button> : ""}
        </div>
    );
};

export default SubscriptionCard;